var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({staticClass:"material-icons"},_vm.$listeners),[_vm._v(_vm._s(_vm.type))])}
var staticRenderFns = []

export { render, staticRenderFns }